export default "__VITE_ASSET__D_SL9LRE__"